// Guess a shipping carrier from a tracking number's shape.
//
// Returns 'usps' | 'ups' | 'fedex' when confident, or null when ambiguous /
// unrecognized. Callers treat null as "don't override" — never as a carrier.
// Deliberately conservative: a wrong auto-select is worse than no auto-select,
// since the user can always pick from the dropdown.
//
// Heuristic mirrors the outbound-shipment guesser (documented contract):
//   UPS   — starts with 1Z, then 16 alphanumerics (18 total).
//   FedEx — 12 or 15 digits (also tolerates the 20/22-digit forms below only
//           when they are NOT USPS IMpb-prefixed).
//   USPS  — 20-22 digits, especially IMpb prefixes (9400/9205/9407/92/93/94),
//           or the 13-char S10 form (2 letters + 9 digits + 2 letters, e.g. US).
// When two carriers could both match a bare digit string, we decline (null).

export function guessCarrier(raw) {
  const s = String(raw || '').replace(/\s+/g, '').toUpperCase();
  if (!s) return null;

  // UPS: 1Z + 16 alphanumerics.
  if (/^1Z[0-9A-Z]{16}$/.test(s)) return 'ups';

  // USPS S10 international: 2 letters, 9 digits, 2 letters (e.g. LZ123456789US).
  if (/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(s)) return 'usps';

  const digits = s.replace(/\D/g, '');
  // If there are non-digits we couldn't classify above, don't guess.
  if (digits.length !== s.length) return null;

  // USPS IMpb: 22 (or 20) digits, leading 91-94 / 9400 / 9205 / 9407 families.
  if ((digits.length === 22 || digits.length === 20) && /^9[1-5]/.test(digits)) {
    return 'usps';
  }

  // FedEx: 12 or 15 digit forms.
  if (digits.length === 12 || digits.length === 15) return 'fedex';

  // 20-22 digits without a USPS prefix is ambiguous — decline.
  return null;
}

export default guessCarrier;
